import LegalLayout, { Section } from "./LegalLayout";

export default function Regulamin() {
  return (
    <LegalLayout
      title="Regulamin serwisu Progres"
      subtitle="Zasady korzystania z aplikacji Progres do śledzenia nawyków, treningów i celów."
      updatedAt="2026-02-08"
      testid="page-regulamin"
    >
      <Section heading="§1. Postanowienia ogólne">
        <p>
          1. Niniejszy Regulamin określa zasady świadczenia usług drogą elektroniczną w ramach
          serwisu <strong>Progres</strong> (dalej: „Serwis"), dostępnego pod adresem internetowym
          Serwisu oraz jako aplikacja PWA (Progressive Web App).
        </p>
        <p>
          2. Operatorem Serwisu i usługodawcą jest <strong>FeGrro Dominik Grzenia</strong>,
          ul. Na Równiku 1, 83-314 Sławki, NIP: <strong>5892037971</strong> (dalej: „Usługodawca").
        </p>
        <p>3. Kontakt z Usługodawcą: e-mail <strong>kontakt@progres.pl</strong>.</p>
      </Section>

      <Section heading="§2. Opis usługi">
        <p>
          1. Serwis to aplikacja internetowa i mobilna (PWA) do samodzielnego śledzenia nawyków,
          planu treningowego (siłownia), pomiarów ciała, celów oraz zadań dziennych.
        </p>
        <p>2. Usługa świadczona jest w modelu abonamentowym w wybranych przez Klienta cyklach.</p>
        <p>
          3. Każde nowo utworzone konto otrzymuje bezpłatny okres próbny w wymiarze{" "}
          <strong>7 dni</strong> od aktywacji konta linkiem wysłanym na e-mail.
        </p>
      </Section>

      <Section heading="§3. Cennik">
        <p>Dostępne pakiety abonamentowe (ceny brutto, PLN):</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>
            <strong>Półroczna</strong> — <strong>120 zł</strong> za 6 miesięcy dostępu (~20 zł/mies.).
          </li>
          <li>
            <strong>Roczna</strong> — <strong>199 zł</strong> za 12 miesięcy dostępu (~16,58 zł/mies.).
          </li>
        </ul>
        <p>
          Płatność następuje z góry za wybrany okres. Abonament <strong>nie odnawia się
          automatycznie</strong> bez wiedzy Klienta — o zbliżającym się końcu okresu Klient
          informowany jest e-mailem.
        </p>
      </Section>

      <Section heading="§4. Zawarcie umowy i rejestracja">
        <p>1. Umowa o świadczenie usług zostaje zawarta z chwilą aktywacji konta w Serwisie.</p>
        <p>
          2. Rejestracja wymaga podania adresu e-mail, hasła oraz akceptacji niniejszego
          Regulaminu, Polityki Prywatności oraz Umowy powierzenia przetwarzania danych osobowych.
        </p>
        <p>
          3. Konto jest aktywowane po kliknięciu w link weryfikacyjny wysłany na podany adres
          e-mail. Link jest ważny 24 godziny.
        </p>
      </Section>

      <Section heading="§5. Płatności">
        <p>
          1. Płatności w Serwisie obsługiwane są przez zewnętrznego operatora płatności:{" "}
          <strong>Przelewy24</strong> (PayPro S.A., ul. Pastelowa 8, 60-198 Poznań, KRS 0000347935).
        </p>
        <p>2. Dostępne metody płatności: przelew online, BLIK, karty płatnicze Visa i Mastercard.</p>
        <p>
          3. Dostęp do usługi aktywowany jest niezwłocznie po zaksięgowaniu płatności (zwykle do
          kilku minut).
        </p>
        <p>
          4. Na życzenie Klienta wystawiana jest faktura VAT — prośbę należy przesłać e-mailem na
          adres kontaktowy Usługodawcy wraz z danymi do faktury.
        </p>
      </Section>

      <Section heading="§6. Rezygnacja i odstąpienie">
        <p>
          1. Klient może zrezygnować z usługi w dowolnym momencie — wystarczy nie opłacić kolejnego
          okresu. Dostęp pozostaje aktywny do końca opłaconego okresu.
        </p>
        <p>
          2. Klient będący konsumentem, który wyraził zgodę na rozpoczęcie świadczenia usługi
          przed upływem 14 dni od zawarcia umowy, traci prawo do odstąpienia od umowy (art. 38
          pkt 13 ustawy o prawach konsumenta) — Serwis jest dostarczany w formie treści cyfrowej.
        </p>
        <p>
          3. Klient w każdej chwili może zażądać usunięcia konta i wszystkich swoich danych,
          wysyłając prośbę e-mailem.
        </p>
      </Section>

      <Section heading="§7. Reklamacje">
        <p>
          1. Klient może zgłosić reklamację e-mailem na adres <strong>kontakt@progres.pl</strong>{" "}
          w terminie 14 dni od stwierdzenia nieprawidłowości.
        </p>
        <p>
          2. Reklamacja powinna zawierać: dane konta Klienta, opis nieprawidłowości oraz
          oczekiwany sposób rozwiązania.
        </p>
        <p>
          3. Usługodawca rozpatruje reklamacje w terminie <strong>14 dni kalendarzowych</strong>{" "}
          od ich otrzymania, wysyłając odpowiedź na adres e-mail Klienta.
        </p>
        <p>
          4. W przypadku uznania reklamacji dotyczącej niedostępności usługi Usługodawca zwraca
          proporcjonalną część opłaty lub przedłuża okres dostępu.
        </p>
        <p>
          5. Konsument ma prawo skorzystać z pozasądowych form rozstrzygania sporów za
          pośrednictwem platformy ODR Komisji Europejskiej:{" "}
          <strong>ec.europa.eu/consumers/odr</strong>.
        </p>
      </Section>

      <Section heading="§8. Dane i odpowiedzialność">
        <p>
          1. Dane wprowadzone przez Klienta (nawyki, treningi, pomiary, cele) pozostają
          własnością Klienta.
        </p>
        <p>2. Usługodawca zapewnia izolację danych pomiędzy kontami oraz codzienne kopie zapasowe.</p>
        <p>
          3. Usługodawca nie ponosi odpowiedzialności za skutki udostępnienia danych logowania
          osobom trzecim przez Klienta.
        </p>
        <p>
          4. Serwis służy wyłącznie do celów informacyjnych i motywacyjnych. Nie stanowi porady
          medycznej ani planu treningowego zatwierdzonego przez trenera — decyzje dotyczące
          zdrowia i treningu Klient podejmuje na własną odpowiedzialność.
        </p>
      </Section>

      <Section heading="§9. Postanowienia końcowe">
        <p>
          1. Zasady przetwarzania danych osobowych określa <a href="/polityka-prywatnosci" className="underline">Polityka Prywatności</a>{" "}
          oraz <a href="/umowa-powierzenia" className="underline">Umowa Powierzenia (DPA)</a>.
        </p>
        <p>
          2. Usługodawca może zmienić Regulamin z ważnych przyczyn, informując Klientów e-mailem
          z 14-dniowym wyprzedzeniem.
        </p>
        <p>
          3. W sprawach nieuregulowanych zastosowanie mają przepisy prawa polskiego, w szczególności
          Kodeksu Cywilnego oraz Ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą
          elektroniczną.
        </p>
      </Section>
    </LegalLayout>
  );
}
